import { initAccordion } from './components/accordion';
import { initBurger } from './components/burger';
import { initModals } from './components/modals';
import { initSlider } from './components/slider';
import { initVideo } from './components/video';
import { initAdvantages } from './modules/advantages';
import { initEditorialFilter } from './modules/editorial-filter';
import { initFeatureList } from './modules/feature-list';
import { initHeader } from './modules/header';
import { initMultiEditorial } from './modules/multi-editorial';
import { initPricingBoxes } from './modules/pricing-boxes';
import { initStageSlider } from './modules/stage-slider';
import { initTestimonialsModule } from './modules/testimonials';

import { initConsentManagement } from './helpers/consent-management';

import { initTracking } from './tracking';

import { initShowToggles } from './helpers/hide-show';
import { initIframe } from './blog/iframe';
import { initTable } from './blog/table';
import { initCaptchas } from './helpers/captchas';
import { initMatchImageHeight } from './helpers/match-image-height';

import { initFreeTrials } from './forms/free-trial';
import { initQuickorder } from './forms/quickorder';
import { initDirectDebit } from './forms/direct-debit';
import { initLogin } from './forms/login';
import { initAdvancedSelects } from './forms/advanced-select';
import { initPreselect } from './forms/preselect';
import { initPrefill } from './forms/prefill';
import { initCustomerReferral } from './forms/customer-referral';

import { ConsentFormHandlerFactory } from './forms/consent-form-handler/ConsentFormHandlerFactory';
import { EbueroConsentFormHandler } from './forms/consent-form-handler/EbueroConsentFormHandler';

import { generalCallbacks } from './form-callbacks/general';
import { consentCallbacks } from './form-callbacks/consent';
import { freeTrialCallbacks } from './form-callbacks/free-trial';
import { quickorderCallbacks } from './form-callbacks/quickorder';
import { directDebitCallbacks } from './form-callbacks/direct-debit';
import { customerReferralCallbacks } from './form-callbacks/customer-referral';
import { whitePaperDownloadCallbacks } from './form-callbacks/whitepaper-download';
import { loginCallbacks } from './form-callbacks/login';

import { initPreload } from './helpers/preload';
import { generateUuid } from './helpers/strings';
import { shiftSubdomain } from './helpers/extract-domain';
import { initAnchorLinkOffset } from './helpers/anchor-link-offset';
import { initChat } from './helpers/chat';
import { initParameterLinks } from './helpers/parameter-links';

// Fix jumping layout for content-visibility: auto
const cvObserver = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.style.contentVisibility = 'visible';
			observer.unobserve(entry.target);
		}
	});
});

const initializers = [
	initAccordion,
	initBurger,
	initModals,
	initSlider,
	initVideo,
	initAdvantages,
	initEditorialFilter,
	initFeatureList,
	initHeader,
	initMultiEditorial,
	initPricingBoxes,
	initStageSlider,
	initTestimonialsModule,
	initAnchorLinkOffset,
	initConsentManagement,
	initParameterLinks,

	initTracking,

	initShowToggles,
	initIframe,
	initTable,
	initAdvancedSelects,
	initFreeTrials,
	initDirectDebit,
	initQuickorder,
	initLogin,
	initPreselect,
	initPrefill,
	initCustomerReferral,

	initPreload,
	initCaptchas,
	initMatchImageHeight,

	initChat,
];

const initialize = () => {
	ConsentFormHandlerFactory.getInstance().registerHandler(new EbueroConsentFormHandler());

	document.querySelectorAll('main img').forEach((el) => cvObserver.observe(el));

	initializers.forEach((initializer) => {
		try {
			initializer();
		} catch (e) {
			console.log(e);
		}
	});
};

initialize();

Object.assign(
	window,
	generalCallbacks,
	consentCallbacks,
	freeTrialCallbacks,
	quickorderCallbacks,
	loginCallbacks,
	directDebitCallbacks,
	customerReferralCallbacks,
	whitePaperDownloadCallbacks
);
window.generateUuid = generateUuid;
window.shiftSubdomain = shiftSubdomain;

// Process all libsLoadedScripts directly now
window.addLibsLoadedScript = (fn) => fn();

// Execute all scripts that have been queued for execution
if (typeof window.libsLoadedScripts === 'object') {
	window.libsLoadedScripts.forEach((fn) => {
		try {
			fn();
		} catch (e) {
			console.error(e);
		}
	});
}
